import {PropsWithChildren} from 'react';
import {coverHeight} from '../../lib/style';
import {Box} from '@mui/material';
import {SVGSpec} from '../Admin/Form/Picture/svgTypes.ts';

type Props = PropsWithChildren<{
    svgSpec?: SVGSpec | undefined;
    rounded?: boolean;
}>;

export default function LogoWrapper({children, svgSpec, rounded}: Props) {
    return (
        <Box
            sx={theme => ({
                backgroundColor: svgSpec?.bgColor,
                img: {
                    maxHeight: coverHeight,
                },
                ...(svgSpec?.scale
                    ? {
                          [import.meta.env.SSR
                              ? '& > div'
                              : '& > div:has(.loaded)']: {
                              transform: `scale(${Math.round(svgSpec.scale) / 100})`,
                          },
                      }
                    : {}),
                ...(rounded
                    ? {
                          borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
                          overflow: 'hidden',
                      }
                    : {}),
            })}
        >
            <div
                style={{
                    width: '100%',
                    height: '100%',
                }}
            >
                {children}
            </div>
        </Box>
    );
}
